import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import CommonCustomerType from 'common/components/entities/CustomerType/CustomerTypeNew'
import { CustomerTypeInterface } from 'common/types/entities/CustomerTypeInteface'
import React from 'react'

interface CustomerTypeProps {
  entity: CustomerTypeInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

function CustomerType({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: CustomerTypeProps) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonCustomerType />
    </BaseEntityNew>
  )
}
export default CustomerType
